import React from "react"
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import YoutubePlayer from '../youtube-player/youtubePlayer';
import Video from '../../atoms/video/video';
import "./videoPlayer.scss"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const VideosPlayer = (props: ReferenciaContenido) => {

   return (
      <div className="m-videos">
         <div className="m-videos__upper">
            <h2 className="m-videos__upper__title">{props.tituloGeneral}</h2>
            <p className="m-videos__upper__subtitle">{documentToReactComponents(props.descripcion.json)}</p>
         </div>
         <div className="m-videos__first">
            <div className="m-videos__first__video">
               {props.referenciaPlantillaContenido[0].videoPrincipal ?
                  <Video video={props.referenciaPlantillaContenido[0].videoPrincipal} download />
               :
                  <YoutubePlayer youtubeId={props.referenciaPlantillaContenido[0].youtubeId} />
               }
            </div>
         </div>
         <div className="m-videos__list">
            {props.referenciaPlantillaContenido.map((video, key) => {
               if (key > 0) {
                  return (
                     <>
                        {video.videoPrincipal ?
                           <div key={key} className="m-videos__list__video">
                              <Video video={video.videoPrincipal} download />
                           </div>
                        :
                           <div key={key} className="m-videos__list__youtube">
                              <YoutubePlayer youtubeId={video.youtubeId} />
                           </div>
                        }
                     </>
                  )
               }
            })}
         </div>
      </div>
   )
}

export default VideosPlayer